import { MimeType_csv, MimeType_html, Module } from '@nu-art/ts-common';
import { ModuleFE_XHR } from '@nu-art/thunderstorm-frontend/index';
import { HeaderKey_ContentType } from '@nu-art/thunderstorm-shared';
import { ApiDef_DiseaseProfileImport } from '@app/data-migration-shared';
/**
 * Calls the disease-profile-import endpoints sending the raw CSV File as `text/csv`.
 * Both endpoints take a `void` JSON body, so the File travels as the raw request body
 * (the backend reads the stream directly) — hence ModuleFE_XHR, not `apiWithBody`.
 */
class ModuleFE_DiseaseProfileImport_Class extends Module {
    /** Dry-run: returns the structural counts + any validation errors (HTTP 200, errors in the body). */
    validateDiseaseProfile = (file) => this.csvRequest(ApiDef_DiseaseProfileImport._v1.validateDiseaseProfile, file).executeSync();
    /** Commit: returns DPImportResult (has `diseaseProfileId`) on success, or DPImportSummary with errors if it still fails validation. */
    importDiseaseProfile = (file) => this.csvRequest(ApiDef_DiseaseProfileImport._v1.importDiseaseProfile, file).executeSync();
    /**
     * Attaches the optional HTML to a just-imported disease profile. The HTML travels as the raw
     * text/html body (like the CSV, hence ModuleFE_XHR) and the diseaseProfileId as a query param.
     * Resolves to the persisted download URL; on failure the backend rolls the whole import back and
     * this rejects.
     */
    attachHtml = (diseaseProfileId, file) => ModuleFE_XHR.createRequest(ApiDef_DiseaseProfileImport._v1.attachHtml)
        .setUrlParams({ diseaseProfileId })
        .setTimeout(ApiDef_DiseaseProfileImport._v1.attachHtml.timeout)
        .setHeader(HeaderKey_ContentType, MimeType_html)
        .setBody(file, false)
        .executeSync();
    csvRequest = (apiDef, file) => ModuleFE_XHR.createRequest(apiDef)
        .setTimeout(apiDef.timeout)
        .setHeader(HeaderKey_ContentType, MimeType_csv)
        .setBody(file, false);
}
export const ModuleFE_DiseaseProfileImport = new ModuleFE_DiseaseProfileImport_Class();
//# sourceMappingURL=ModuleFE_DiseaseProfileImport.js.map